export default __webpack_public_path__ + "static/media/EmmmLogo.5b72fdb8.webp";